import React, { Component, PropTypes } from "react";
import LeftComponent from "components/Authorization/LeftComponent";
import LoginForm from "components/Authorization/Login/LoginForm";
import { connect } from "react-redux";
import actions from "actions";
const { login } = actions;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "", passwordType: "password" };
  }

  onFieldChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onPasswordTypeChange = (status) => {
    this.setState({
      passwordType: status ? "text" : "password",
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    this.props.login(
      email.toLowerCase(),
      password,
      this.props.location.query.redirectBack
    );
  };

  render() {
    const { email, password } = this.state;

    return (
      <main className="">
        <div className="container_content_signin">
          <LeftComponent />
          <LoginForm
            email={email}
            password={password}
            passwordType={this.state.passwordType}
            onFieldChange={this.onFieldChange}
            onSubmit={this.onSubmit}
            onPasswordTypeToggle={this.onPasswordTypeChange}
            redirectBack={this.props.location.query.redirectBack}
            isAdmin={false}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
  return {
    login: (email, password, redirect) => {
      dispatch(login(email, password, redirect));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Authorization/Login/Login.js